<template>
  <v-dialog
    v-model="show"
    :persistent="loading"
    width="500"
  >
    <v-card>
      <v-form
        v-model="validForm"
        :disabled="loading"
        @submit.prevent="login"
      >
        <v-toolbar flat color="grey lighten-2">
          <v-card-title class="headline">Log in parent</v-card-title>
          <v-spacer />
          <v-btn
            :disabled="loading"
            icon
            class="mr-0"
            @click="closeModal"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-6">
          <v-text-field
            v-model="formData.email"
            :rules="rules.email"
            type="email"
            label="Email"
            outlined
            color="blue darken-2"
          />
          <v-text-field
            v-model="formData.password"
            :rules="rules.password"
            type="password"
            label="Password"
            outlined
            color="blue darken-2"
          />
          <div class="forgot-password">
            <a href="#" @click.prevent="setForgotPasswordModalState(true)">Forgot password</a>
          </div>
          <div v-if="errorMessage" class="error-container">
            {{ errorMessage }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="loading"
            :disabled="!validForm"
            type="submit"
            large
            block
            color="blue darken-2"
            class="white--text"
          >
            Login
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import { emailRegex, passwordRegex } from '@/helpers/regex';

export default {
  name: 'LogInParentModal',
  data() {
    return {
      formData: {
        email: '',
        password: '',
      },
      validForm: false,
      loading: false,
      errorMessage: null,
      rules: {
        email: [
          v => !!v || 'Required field',
          v => emailRegex.test(v) || 'Invalid email format',
        ],
        password: [
          v => !!v || 'Required field',
          v => v.length >= 8 || 'Min length: 8',
          v => passwordRegex.test(v)
            || 'Password must be at least 8 characters long and contain at least one lowercase letter, uppercase letter, number and symbol',
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      getLogInModalState: 'getLogInModalState',
      redirectCallback: 'getLogInModalCallback',
    }),
    show: {
      get() {
        return this.getLogInModalState;
      },
      set(value) {
        this.setLogInModalState(value);
      },
    },
  },
  methods: {
    ...mapActions({
      setLogInModalState: 'setLogInModalState',
      setForgotPasswordModalState: 'setForgotPasswordModalState',
      setLogInModalCallback: 'setLogInModalCallback',
      loginParent: 'parent/loginParent',
      loadParent: 'parent/loadParent',
    }),
    closeModal() {
      this.show = false;
      this.setLogInModalCallback(null);
    },
    async login() {
      try {
        if (this.loading) return;

        this.errorMessage = null;
        this.loading = true;

        const credentials = Object.assign({ rememberMe: true }, this.formData);
        const res = await this.loginParent(credentials);

        if (this.redirectCallback) {
          this.redirectCallback();
          return;
        }

        if (res.status === 200) {
          await this.loadParent();
          this.closeModal();
        }
      } catch (err) {
        this.errorMessage = get(err, 'response.data.message', 'Failed to login');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error-container {
  color: #cc0000;
  font-size: 16px;
  padding: 20px 8px 8px;
}
</style>
